import { render, staticRenderFns } from "./breadcrumbLayout.vue?vue&type=template&id=350dd57b&scoped=true&"
import script from "./breadcrumbLayout.vue?vue&type=script&lang=js&"
export * from "./breadcrumbLayout.vue?vue&type=script&lang=js&"
import style0 from "./breadcrumbLayout.vue?vue&type=style&index=0&id=350dd57b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350dd57b",
  null
  
)

export default component.exports